//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBoardWithAllFieldsBelow from '@/elements/editorial/cms-layout-variants-wrappers/rb-board-with-fields-below/rb-board-with-fields-below.vue'
import { MOBILE } from '@/scripts/constants/media-query'
export default {
  name: 'rb-board-with-fields-on-no-icons-mobile',
  extends: RbBoardWithAllFieldsBelow,

  computed: {
    isMobile() {
      return [MOBILE].includes(this.$mq)
    },
    mobileColumn() {
      return this.isMobile ? 6 : 0
    },
  },
}
